import Validators from "redux-form-validators";

export const required = value => (value ? undefined : "Required");

export const validate = {
  alphaNumeric: function(string, count) {
    return /^[a-z0-9]+$/i.test(value);
  },
  alphaNumericSpace: function(string, count) {
    return /^[a-z0-9\s]+$/i.test(value);
  },
  letters: function(string, count) {
    return /^[a-z]+$/i.test(value);
  },
};

export const messages = {
  alphaNumeric: "Only allows letters and numbers",
  alphaNumericSpace: "Only allows letters, numbers and whitespaces",
  letters: "Only allows letters",
};

const overrideMessages = () =>
  Object.assign(Validators.messages, {
    email: "is not a valid email address",
    presence: "This field is required",
    greaterThanOrEqualTo: "You must enter a valid positive number",
  });

export const wrapperValidate = validations => (values, allValues, props) => {
  overrideMessages();
  const errors = {};
  for (let field in validations) {
    let value = values[field];
    errors[field] = validations[field]
      .map(validateField => {
        return validateField(value, values);
      })
      .find(x => x);
  }
  return errors;
};
